import { useCallback } from "react";
import { CACHE_EXPIRY_MS } from "shared/consts";

export function useIsCacheExpired() {
  return useCallback((lastUpdated: Date): boolean => {
    const now = new Date();
    return now.getTime() - lastUpdated.getTime() > CACHE_EXPIRY_MS;
  }, []);
}
